import RankSix from '@assets/icons/rank-six.svg'
import { Icon } from './Icon'

export const RankSixIcon = Icon(RankSix)
